
<div class="wrapper">
  <router-outlet></router-outlet>
  <app-footer *ngIf="showFooter"></app-footer>
  <!-- Scroll to top button -->
  <a *ngIf="showBackToTop" (click)="scrollToTop()" class="btn btn-secondary btn-square rounded-circle back-to-top">
    <i class="fa fa-arrow-up text-white"></i>
  </a>
  <!-- end Scroll to top button -->
</div>